import Vue from "vue";
import {Room} from "@/core/api/room.api";

export default {
    addUser: (state, user) => {
        if(!user) return
        Vue.set(user, 'time', user.totalTimeSeconds)

        const userList = state.camStudyUserList
        const u = userList.find(u => u.email === user.email)
        if(u) {
            const profileImageUrl = u.profileImageUrl || user.profileImageUrl
            Object.assign(u, user)
            Vue.set(u, 'time', user.totalTimeSeconds)
            u.profileImageUrl = profileImageUrl
        } else {
            userList.push(user)
        }
    },
    addStudyData: (state, {studyData, userId, init = false}) => {
        if(!studyData) return
        Vue.set(studyData, 'time', studyData.totalTimeSeconds)

        if(userId) {
            Vue.set(studyData, 'userId', userId)
        }

        if(studyData.state === 'start' && init) {
            const me = this.getters['camstudy/getCamStudyUser']()
            me && (studyData.totalTimeSeconds += Math.floor((new Date(me.joinDate).getTime() - new Date(studyData.startDate).getTime()) / 1000) || 0)
        }

        const studyDataList = state.studyDataList
        const sd = studyDataList.find(sd => sd.userId === studyData.userId)

        if(sd) {
            Object.assign(sd, studyData)
            Vue.set(sd, 'time', studyData.totalTimeSeconds)
        } else {
            studyDataList.push(studyData)
        }
    },
    addUserBan: (state, userBan) => {
        const userBanList = state.camStudyUserBanList
        const oriUserBan = userBanList.find(ub => ub.email === userBan.email)
        if (oriUserBan) {
            Object.assign(oriUserBan, userBan)
        } else {
            userBanList.push(userBan)
        }
    },
    removeUserBan: (state, userBan) => {
        const userBanList = state.camStudyUserBanList
        const idx = userBanList.findIndex(ub => ub.email === userBan.email)
        if (idx >= 0) {
            userBanList.splice(idx, 1)
        }
    },
    addStopwatch: function(state, {stopwatch, userId, init=false})  {
        if(!stopwatch) return
        Vue.set(stopwatch, 'time', stopwatch.totalTimeSeconds)

        if(userId) {
            Vue.set(stopwatch, 'userId', userId)
        }

        const stopwatchList = state.stopWatchList
        const sw = stopwatchList.find(sw => sw.userId === stopwatch.userId)

        if(sw) {
            Object.assign(sw, stopwatch)
            Vue.set(sw, 'time', stopwatch.totalTimeSeconds)
        } else {
            stopwatchList.push(stopwatch)
        }
    },
    addStopwatchTime: function (state) {
        const now = Room.getCurrentDateTime()
        state.stopWatchList.forEach(obj => {
            if(obj.state === 'start') {
                obj.time = Math.max(
                    obj.totalTimeSeconds +
                    Math.floor((now - new Date(obj.startDate).getTime()) / 1000)
                    , 0)
            }
        })

        state.studyDataList.forEach(obj => {
            if(obj.studyState !== 'start') {
                return;
            }
            obj.time = Math.max(
                obj.totalTimeSeconds +
                Math.floor((now - new Date(obj.startDate).getTime()) / 1000)
                , 0)
            const user = this.getters['camstudy/getCamStudyUser'](obj.userId)
            if(user) {
                user.time = Math.max(
                    user.totalTimeSeconds +
                    Math.floor((now - new Date(obj.startDate).getTime()) / 1000)
                    , 0)
            }
        })
    },
    setUserStudyData: function(state, studyData)  {
        const me = this.getters['camstudy/getCamStudyUser']()
        if(!me) return

        if(me?.camStudyUserData) {
            Object.assign(me?.camStudyUserData, studyData)
        } else {
            me.camStudyUserData = studyData
        }

    },
    setCamStudy: (state, camStudy) => {
        state.camStudy = camStudy
    },
    blockUserScreen: (state, {userId, block}) => {
        Vue.set(state.screenBlockList, userId, block)
    },
    addUserPoint: function(state, {userId, penalty, pPoint, point}) {
        const user = this.getters['camstudy/getCamStudyUser'](userId)
        if(!user) return

        if(penalty) {
            user.pPoint = pPoint
        } else {
            user.point = point
        }
    },
    setWhiteNoisePlayList: (state, playList) => {
        state.whileNoisePlayList = playList
    },
    setPersonalSetting: (state, personalSetting) => {
        Object.keys(personalSetting).forEach((key) => {
            Vue.set(state.personalSetting, key, personalSetting[key])
        })
    },
    setHashTagList: (state, hashTagList) => {
        Vue.set(state, 'hashTagList', hashTagList)
    },
    changeCamStudyInfo: (state, data) => {
        if (!data) {
            return
        }
        if (data.hashtagList) {
            Vue.set(state, 'hashTagList', data.hashtagList)
        }
        if (data.endResvDate) {
            state.camStudy.endResvDate = data.endResvDate
        }
        if (data.studyTitle) {
            state.camStudy.studyTitle = data.studyTitle
        }
        if (data.studyContent !== undefined) {
            state.camStudy.studyContent = data.studyContent
        }
        if (data.usePoint !== undefined) {
            state.camStudy.usePoint = data.usePoint
        }
        if (data.targetType !== undefined) {
            state.camStudy.targetType = data.targetType
        }
        if (data.targetTime !== undefined) {
            state.camStudy.targetTime = data.targetTime
        }
        if (data.useVacancyDetection !== undefined) {
            state.camStudy.useVacancyDetection = data.useVacancyDetection
        }
        if( data.vacancyDetectMinutes !== undefined) {
            state.camStudy.vacancyDetectMinutes = data.vacancyDetectMinutes
        }
    },
    setCurrentWhiteNoise: function(state, whiteNoise) {
        state.currentWhiteNoise = whiteNoise;
    },
    setRoomImagePath: (state, path) => {
        state.roomImagePath = path
    },
    setMyInfoSetting: (state, setting) => {
        Object.assign(state.myStudyInfoSetting, setting)
    },
    setDDayList: (state, dDayList) => {
        if(!dDayList) return

        state.dDayList = dDayList
    },
    changeMyMsg: function(state, {userId, myMsg})  {
      const user = this.getters['camstudy/getCamStudyUser'](userId)
      if(!user) return

      user.myMsg = myMsg
    },
    setStopWatchSetting: function(state, setting) {
      state.stopWatchSetting = setting;
    },
    changeStopWatchSetting: function(state, {userId, camStudyUserItemSetting}) {
      const user = this.getters['camstudy/getCamStudyUser'](userId)
      if(!user) return

      Vue.set(user.camStudyUserItemSettingList, 0, camStudyUserItemSetting)
    },
    changeUsername: function(state, { email, username }) {
        const userList = state.camStudyUserList
        const u = userList?.find(u => u.email === email)
        if(u) {
            u.username = username
        }
    },
    changeUserProfileImage: function (state, { userId, profileImageUrl }) {
        const user = this.getters['camstudy/getCamStudyUser'](userId)
        if (user) {
            user.profileImageUrl = profileImageUrl
        }
    },
    setPremiumUser: (state, isPremium) => {
        state.isPremiumUser = isPremium
    },
    setUserPremiumLevel: (state, data) => {
        state.userPremiumLevel = data
    },
    setUserTrial: (state, trials) => {
        state.userTrialList = trials
    },
}
